import { Reveal } from "./Reveal";

export const SectionHeading = ({ overline, title, description, className = "" }) => (
  <div className={`max-w-3xl ${className}`}>
    <Reveal>
      <p className="flex items-center gap-3 font-mono text-xs uppercase tracking-[0.25em] text-cyan-400">
        <span className="inline-block h-px w-8 bg-cyan-400/60" />
        {overline}
      </p>
    </Reveal>
    <Reveal delay={0.1}>
      <h2 className="mt-5 font-display text-2xl sm:text-3xl lg:text-4xl font-semibold tracking-tight text-white leading-[1.12]">
        {title}
      </h2>
    </Reveal>
    {description && (
      <Reveal delay={0.2}>
        <p className="mt-5 text-base sm:text-lg text-slate-400 leading-relaxed">{description}</p>
      </Reveal>
    )}
  </div>
);
